import { useSelector } from 'react-redux';
import { ProductsSelectors } from 'reactApp/modules/products/products.selectors';
import { EProductPeriod } from 'reactApp/modules/products/products.types';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { RootState } from 'reactApp/store';

import { EShowTariffType, TariffInfo } from '../UploadBigFileDialog.types';

const TRIAL_PRODUCT_ID = 'W128G1m_special_welcome_single_quota_cloud';

export const useTariff = (fileSizeBytes: number): TariffInfo => {
    const { isFull: isOverQuota } = useSelector(UserSelectors.getCloudSpace);

    const trial = useSelector((state: RootState) => ProductsSelectors.getProductById(state, TRIAL_PRODUCT_ID));
    const { product } = useSelector((state: RootState) =>
        ProductsSelectors.getProductAndTariffByQuota(state, fileSizeBytes, EProductPeriod.year, false)
    );
    const isPaidUser = useSelector(UserSelectors.isPaidUser);

    // если в квоту триала помещаются загружаемые файлы, пользователей не платник,
    // не в оверквоте и ему доступен триальный тариф, то показываем его
    const isTrialUser = !isPaidUser && !isOverQuota && Boolean(trial) && fileSizeBytes < trial.space.original;

    return {
        trial,
        usualProduct: product,
        showTariffType: isTrialUser ? EShowTariffType.TRIAL : EShowTariffType.USUAL_TARIFF,
    };
};
